import React, {useEffect, useState} from 'react';
import './appNewsList.scss';
import {InfoCardType, NewsDataTypes} from "../../../models";
import {newsData} from "../../../data/newsData";
import InfoCard from "../../../components/info-card/InfoCard";
import {useGetArticles} from "../../../operations/queries/useGetArticles";
import { escapeHtml } from 'util/removeHtmlFromString';

const AppNewsList = () => {

    const [articles, setArticles] = useState<Array<NewsDataTypes>>([])
    const {data: articleData} = useGetArticles();

    useEffect(() => {
        if (!articleData) return
        let articleList: Array<NewsDataTypes> = [];

        articleData.forEach((article: any) => {
            const articleInfo = article.attributes

            articleList.push({
                id: article.id,
                date: articleInfo.date?.split("T")[0],
                image: process.env.REACT_APP_BASE_URL + articleInfo.image.data.attributes.url,
                author: articleInfo.author,
                heading: articleInfo.heading,
                description: articleInfo.description,
                body: escapeHtml(articleInfo.body),
                link: articleInfo?.link ?? "N/A",
                isPopular: articleInfo?.isPopular ?? 'N/A',
                headerImage: process.env.REACT_APP_BASE_URL + articleInfo.headerImage.data.attributes.url
            })
        })
        setArticles(articleList)
    }, [articleData]);
    return (
        <div className={'app-news'}>
            <div className={'app-news_wrapper'}>
                <div className={'app-news_wrapper_top'}>
                    <h1 id={'heading'}>All Articles</h1>
                    <div className={'app-news_wrapper_top_list'}>
                        {articles.map(({id, date, heading, description, link, image}, index) => (
                            <InfoCard key={index.toString() + id} id={id} date={date} heading={heading}
                                      description={description} link={'app/news/news'}
                                      image={image}/>
                        ))}
                    </div>
                </div>
                {/*<div className={'app-news_wrapper_bottom'}>*/}
                {/*    <h1 id={'heading'}>Other News & Articles</h1>*/}
                {/*    <div className={'app-news_wrapper_bottom_list'}>*/}
                {/*        {otherNews.map(({id, date, heading, description, link, image}, index) => (*/}
                {/*            <InfoCard key={index.toString() + id} id={id} date={date} heading={heading}*/}
                {/*                      description={description} link={'app/news/news'}*/}
                {/*                      image={image}/>*/}
                {/*        ))}*/}
                {/*    </div>*/}
                {/*</div>*/}
            </div>

        </div>
    );
};

export default AppNewsList;
